import axios from "axios";

// Client HTTP partagé pointant sur l'API Salesforce Connect.
// Les options par appel (withCredentials, headers Authorization, params)
// restent à la charge de l'appelant.
const api = axios.create({
  baseURL: process.env.REACT_APP_SFCONNECT_URL,
});

export default api;
